import { render, staticRenderFns } from "./SidebarNestedArticleItem.vue?vue&type=template&id=2d2d0bcb&"
import script from "./SidebarNestedArticleItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarNestedArticleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports